module.exports = __webpack_public_path__ + "img/driver-temperature-good.2f11b784.png";